import { RacingTracks } from "@/constants/tracks/RacingTracks";

import { MetaInfoTypes } from "../brandVariables.types";

export const logitechMeta: MetaInfoTypes = {
  trackName: "Grand Oak (Club Circuit)",
  playerTeamOrCarValue: "McLaren P1 GTR",
  playerTeamOrCarKey: "Car",
  map: RacingTracks["logitech-l5vzz"],
  1: {
    key: "Turns:",
    value: "7",
  },
  2: {
    key: "Circuit length:",
    value: "2.62 km",
  },
  3: {
    key: "Track difficulty:",
    value: "very easy",
  },
  4: {
    key: "Lap record:",
    value: "00:34.731",
  },
};
